import { toast } from "react-toastify";

const commonOptions = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "dark", // 🌙 dark mode
};

export const showToast = {
    success: (msg) => toast.success(msg, commonOptions),
    warning: (msg) => toast.warning(msg, commonOptions),
    error: (msg) => toast.error(msg, commonOptions),
    info: (msg) => toast.info(msg, commonOptions),
};
